export default "__VITE_ASSET__DspIuS7Z__"